/* Small enhancements for the core storefront; all buying/navigation links work without JS. */
(() => {
  const menu = document.getElementById('drawer');
  const trigger = document.getElementById('openDrawer');
  if (menu && trigger) {
    // Keep the modal outside main so the background can be isolated from keyboard and AT.
    document.body.append(menu);
    let isolated = [];
    let wasOpen = false;
    let previousOverflow = '';
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    menu.setAttribute('aria-label', 'Menu');
    trigger.setAttribute('aria-controls', 'drawer');
    const sync = () => {
      const open = menu.classList.contains('open');
      trigger.setAttribute('aria-expanded', String(open));
      if (open === wasOpen) return;
      wasOpen = open;
      if (open) {
        previousOverflow = document.documentElement.style.overflow;
        isolated = [...document.body.children].filter(node => node !== menu && node instanceof HTMLElement && !node.inert && !['SCRIPT','STYLE','LINK'].includes(node.tagName));
        isolated.forEach(node => { node.inert = true; });
        document.documentElement.style.overflow = 'hidden';
      } else {
        isolated.forEach(node => { if (node.isConnected) node.inert = false; });
        isolated = [];
        document.documentElement.style.overflow = previousOverflow;
        const returnTarget = trigger.getClientRects().length ? trigger : document.querySelector('header.site .logo');
        returnTarget?.focus();
      }
    };
    new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['class'] });
    sync();
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !menu.classList.contains('open')) return;
      const items = [...menu.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = items[0];
      const last = items.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
  }
  document.addEventListener('play', event => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    for (const video of document.querySelectorAll('.jive-refresh video')) {
      if (video !== event.target) video.pause();
    }
  }, true);
})();

// Small, accessible product previews and formula tabs. Both formulas remain visible without JS.
(() => {
  document.querySelectorAll('[data-home-product]').forEach(card => {
    card.addEventListener('click', event => {
      const button = event.target.closest('[data-home-flavor]');
      if (!button) return;
      card.querySelectorAll('[data-home-flavor]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const photo = card.querySelector('[data-home-product-image]');
      photo.src = button.dataset.image;
      photo.alt = `${button.dataset.homeFlavor} Protein Hydrator`;
      card.querySelector('[data-home-flavor-label]').textContent = button.dataset.homeFlavor;
      card.querySelectorAll('[data-home-product-link]').forEach(link => { link.href = button.dataset.url; });
    });
  });
  document.querySelectorAll('[data-jive-mechanisms]').forEach(section => {
    const tabs = [...section.querySelectorAll('[data-mechanism-tab]')];
    const panels = [...section.querySelectorAll('[data-mechanism-panel]')];
    section.querySelector('[role="tablist"]').hidden = false;
    const select = selected => {
      tabs.forEach(tab => { const active = tab === selected; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.dataset.mechanismPanel !== selected.dataset.mechanismTab; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', `mechanism-tab-${panel.dataset.mechanismPanel}`); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(tabs[next]); tabs[next].focus();
      });
    });
    select(tabs[0]);
  });
})();
